import { addDays, addYears, startOfDay } from 'date-fns';

import { DATE_WITH_TIMEZONE_FORMAT } from '@iconik-io/core/src/date/date_formats';
import { format } from '@iconik-io/core/src/date/format';

export const DEFAULT_EXPIRATION_TIME_DAYS = 60;

type ExpirationDateSetType = {
  expiresAt: string;
  expirationMinDate: string;
  expirationMaxDate: string;
};
export const getExpirationDateSet = (
  expirationTime = DEFAULT_EXPIRATION_TIME_DAYS,
): ExpirationDateSetType => {
  const expiresAt =
    format(
      addDays(startOfDay(new Date()), expirationTime),
      DATE_WITH_TIMEZONE_FORMAT,
    ) ?? 'Invalid date';
  const expirationMinDate = addDays(new Date(), 1).toISOString();
  const expirationMaxDate = addYears(startOfDay(new Date()), 10).toISOString();
  return {
    expiresAt,
    expirationMinDate,
    expirationMaxDate,
  };
};
